import { render } from "./FolderSelect.vue?vue&type=template&id=ba61dd48&scoped=true"
import script from "./FolderSelect.vue?vue&type=script&lang=js"
export * from "./FolderSelect.vue?vue&type=script&lang=js"

import "./FolderSelect.vue?vue&type=style&index=0&id=ba61dd48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba61dd48"]])

export default __exports__